import firebase from "firebase/app";
import "firebase/auth";
import store from "@/store";
import moment from 'moment/moment';

let lastActivityTs = Date.now();
let intervalId: number | null = null;

// References to the event handler for proper removal
const markActivity = () => {
  lastActivityTs = Date.now();
  console.log(`[IDLE session timer] ACTIVITY DETECTED ${new Date().toLocaleString()}`);
};

const CHECK_INTERVAL_MS = 30 * 1000;    // check every 30 seconds

export const initIdleSessionTimer = async (idleMaxAgeSec: number) => {
  console.log("[IDLE session timer] initIdleSessionTimer()");
  if (!idleMaxAgeSec) return;

  lastActivityTs = Date.now();

  // Track real user activity
  window.addEventListener("click", markActivity);
  window.addEventListener("keydown", markActivity);
  window.addEventListener("mousemove", markActivity);
  window.addEventListener("scroll", markActivity);

  intervalId = window.setInterval(async () => {
    if (document.visibilityState !== "visible") return;

    const firebaseUser = firebase.auth().currentUser;
    if (!firebaseUser || firebaseUser.isAnonymous) return;

    const timeSinceLastActivity = Date.now() - lastActivityTs;

    console.group("IDLE Session Timer");
    console.log("Time since last activity: ", moment(timeSinceLastActivity).toDate().toLocaleString());
    console.log("Time since last activity (seconds): ", timeSinceLastActivity / 1000);
    console.log(`Field idleMaxAgeSec: ${idleMaxAgeSec}`);
    console.groupEnd();

    if ((timeSinceLastActivity / 1000) >= idleMaxAgeSec) {
      store.dispatch('openSessionTimeout', true);
      store.dispatch("userSignOutBySessionExpired");
    }
  }, CHECK_INTERVAL_MS)
};

export const stopIdleSessionTimer = () => {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
    console.log("[IDLE session timer] stopped");
  }

  lastActivityTs = Date.now();

  // Remove activity listeners
  window.removeEventListener("click", markActivity);
  window.removeEventListener("keydown", markActivity);
  window.removeEventListener("mousemove", markActivity);
  window.removeEventListener("scroll", markActivity);
};
